import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { LookupDataService } from '../../services/lookup-data.service';
import { LookupItem } from '../../models/lookup-item';
import { AssessmentService } from '../../services/assessment.service';
import {  NonNullableFormBuilder, Validators } from '@angular/forms';
import { PositionsModel } from '../../models/positions';
import { ILookup } from '../../data/Ilookup';
import { LookupMapper } from '../../data/Ikey-value';

@Component({
  selector: 'app-position-dialog',
  templateUrl: './position-dialog.component.html',
  styleUrl: './position-dialog.component.scss'
})
export class PositionDialogComponent {

  assessmentService = inject(AssessmentService);
  formBuilder = inject(NonNullableFormBuilder);

  submitForm = false;
  model: PositionsModel;
  educationLevels!: LookupItem[];
  countries!: LookupItem[];
  titles!: LookupItem[];
  maritalStatus!: LookupItem[];

  constructor(
    public dialogRef: MatDialogRef<PositionDialogComponent>, private lookupDataService: LookupDataService,
    @Inject(MAT_DIALOG_DATA) public data: {
      position: PositionsModel;
      countries: LookupItem[];
      educationLevels: LookupItem[];
      titles: LookupItem[];
      maritalStatus: LookupItem[];
    }
  ) {
    this.model = data.position || new PositionsModel();
    this.countries = data.countries;
    this.educationLevels = data.educationLevels;
    this.titles = data.titles;
    this.maritalStatus = data.maritalStatus;
  }

    ngOnInit(): void {    
      this.handleFormModelBinding();
    }

    handleFormModelBinding() {
      
      // Bind form to model data
      this.positionForm?.patchValue(
        {
          ...this.model,
          passportCountry: LookupMapper.toLookup(this.model.passportCountry)
        }
      );   
      
      // Subscribe to form changes to update model
      this.positionForm?.valueChanges.subscribe(value => {
        this.model = {
          ...this.model!,
          ...value,
          passportCountry: LookupMapper.toKeyValue(value.passportCountry)
        }
      });
    }

  positionForm = this.formBuilder.group({
    jobTitle: ['', [Validators.required]],
    salary: ['', [Validators.min(0)]],
    isAdvertised: [''],
    applicantKnown: ['', [Validators.required]],
    title: [null as ILookup | null],
    titleOther: [''],
    firstName: [''],
    surname: [''],
    dob: [''],
    passportCountry: [null as ILookup | null],
    passportNumber: [''],
    maritalStatus: [null as ILookup | null],
    education: [null as ILookup | null],
    currentlyEmployed: ['']
      });


  close(): void {
    this.submitForm = true;
    if(this.positionForm.valid){
      this.dialogRef.close(this.model);
    }
    // If the form is invalid, stay open and show validation errors
    this.positionForm.markAllAsTouched();
    this.submitForm = false;
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
